module.exports = __webpack_public_path__ + "img/case5-jpg.d12fd707.jpg";